import { useState, useCallback } from 'react'
import req from '@sportninja/common/api/request'

interface UseCheckpointResult {
  isSaving: boolean
  isRestoring: boolean
  saveCheckpoint: (requestId: string) => Promise<boolean>
  restoreCheckpoint: (
    requestId: string
  ) => Promise<{ success: boolean; data?: unknown }>
}

export const useCheckpoint = (): UseCheckpointResult => {
  const [isSaving, setIsSaving] = useState(false)
  const [isRestoring, setIsRestoring] = useState(false)

  const saveCheckpoint = useCallback(
    async (requestId: string): Promise<boolean> => {
      setIsSaving(true)
      try {
        await req(`/scheduler/requests/${requestId}/save-checkpoint`, {
          method: 'POST',
        })
        return true
      } catch {
        return false
      } finally {
        setIsSaving(false)
      }
    },
    []
  )

  const restoreCheckpoint = useCallback(
    async (
      requestId: string
    ): Promise<{ success: boolean; data?: unknown }> => {
      setIsRestoring(true)
      try {
        const { data } = await req(
          `/scheduler/requests/${requestId}/restore-checkpoint`,
          { method: 'POST' }
        )
        return { success: true, data: data?.data ?? data }
      } catch {
        return { success: false }
      } finally {
        setIsRestoring(false)
      }
    },
    []
  )

  return {
    isSaving,
    isRestoring,
    saveCheckpoint,
    restoreCheckpoint,
  }
}

export default useCheckpoint
